/**
 * Anti-scraping email links.
 *
 * Email addresses are never present in the HTML source: each `.js-obfuscated-email`
 * element stores its reversed local-part / domain in data attributes. The real
 * `mailto:` link is assembled client-side only once the user interacts with it
 * (hover, focus, touch or click), so naive scrapers that only read the markup
 * never see a usable address.
 */
(function () {
  'use strict';

  function reverseString(value) {
    return value ? value.split('').reverse().join('') : '';
  }

  function buildHref(el) {
    var user = reverseString(el.getAttribute('data-eu'));
    var domain = reverseString(el.getAttribute('data-ed'));

    if (!user || !domain) return '';

    var href = 'mailto:' + user + '@' + domain;
    var subject = reverseString(el.getAttribute('data-es'));

    if (subject) {
      href += '?subject=' + encodeURIComponent(subject);
    }

    return href;
  }

  function reveal(el) {
    if (el.getAttribute('data-revealed') === 'true') {
      return el.getAttribute('href');
    }

    var href = buildHref(el);
    if (!href) return '';

    el.setAttribute('href', href);

    if (el.getAttribute('data-show') === 'true') {
      var address = href.replace('mailto:', '').split('?')[0];
      var target = el.querySelector('[data-email-text]') || el;
      target.textContent = address;
    }

    el.setAttribute('data-revealed', 'true');
    return href;
  }

  function bind(el) {
    ['mouseenter', 'focus', 'touchstart'].forEach(function (evt) {
      el.addEventListener(evt, function () { reveal(el); }, { passive: true });
    });

    el.addEventListener('click', function (event) {
      var href = reveal(el);
      if (href) {
        event.preventDefault();
        window.location.href = href;
      }
    });
  }

  function init() {
    var links = document.querySelectorAll('.js-obfuscated-email');
    Array.prototype.forEach.call(links, bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
